module.exports = __webpack_public_path__ + "static/media/studio1-4.f2f15054.png";